export type BookingRewardOptions = {
  onCopy?: (code: string) => void
}

export default function initBookingReward(options: BookingRewardOptions = {}): void {
  document.querySelectorAll<HTMLButtonElement>('[data-booking-reward-copy]').forEach((el) => {
    if (!navigator.clipboard) {
      el.hidden = true

      return
    }

    el.addEventListener('click', () => {
      const code = el.getAttribute('data-booking-reward-copy') as string

      navigator.clipboard
        .writeText(code)
        .then(() => {
          options.onCopy?.(code)
        })
        .catch(/* istanbul ignore next */ () => true)
    })
  })
}
